import React, { useState, useLayoutEffect } from 'react';

import { Parallax } from 'rc-scroll-anim';

import { Scrollchor, AnimateConfig, easeOutQuad } from 'react-scrollchor';

import { SimpleLightBox } from '@ui/moleculs/SimpleLightBox';

import playBtn from '@assets/images/videos/play.png';

import mainImgLeft from '@assets/images/videos/video-5/item-1.webp';

import mainImgLeft1 from '@assets/images/videos/video-5/bg/item-1.webp';
import mainImgLeft2 from '@assets/images/videos/video-5/bg/item-2.webp';
import mainImgLeft3 from '@assets/images/videos/video-5/bg/item-3.webp';

import mainImgRight from '@assets/images/videos/video-6/item-1.webp';

import mainImgRight1 from '@assets/images/videos/video-6/bg/item-1.webp';
import mainImgRight2 from '@assets/images/videos/video-6/bg/item-2.webp';

import { stopAllYouTubeVideos } from '@features/helpers';

const defaultAnimate: AnimateConfig = {
  offset: 124,
  duration: 600,
  easing: easeOutQuad,
};

type BlockInfoTypes = {
  headerLeft?: string;
  headerRight?: string;
  index?: number;
  isDesktopOrLaptop?: any;
  active?: boolean;
  onClick: (prop: boolean) => void;
};

export const BlockVideo3: React.FC<BlockInfoTypes> = ({ children, ...props }) => {
  const initOpen = [
    { id: 0, value: false },
    { id: 1, value: false },
  ];
  const [open, setOpen] = useState(initOpen);
  const {
    // headerLeft,
    // headerRight,
    // index,
    active,
    onClick,
    isDesktopOrLaptop
  } = props;

  const toggleOpen = (iframeID: number) => {
    let newArr = [ ...open ];
    newArr[iframeID].value = !newArr[iframeID].value;
    setOpen(newArr);
    stopAllYouTubeVideos();
  };

  const showActive = (!isDesktopOrLaptop && active || isDesktopOrLaptop);
  const showNotActive = (!isDesktopOrLaptop && !active || isDesktopOrLaptop);

  return (
    <>
      <SimpleLightBox open={open[0].value} onClick={() => toggleOpen(0)}>
        <div className={isDesktopOrLaptop ? "w-full h-full" : "portrait:absolute portrait:top-2/4 portrait:transform portrait:-translate-y-2/4 portrait:pt-55 landscape:h-full landscape:w-full mb-17 left-2.5 right-2.5"}>
          <iframe className={isDesktopOrLaptop ? "w-full h-full" : "portrait:absolute top-0 -left-0 w-full h-full" } width="560" height="315" src="https://www.youtube.com/embed/KuuW5FA0JQQ?enablejsapi=1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
        </div>
        <div className="flex absolute lg:relative bottom-5 lg:bottom-0 justify-center mt-5">
          <Scrollchor
            className="bg-izRuText text-white text-md font-serif px-7 py-3.5 rounded-full"
            animate={{ duration: 1000, easing: easeOutQuad, offset: 0 }}
            to="#interview"
            beforeAnimate={() => toggleOpen(0)}
            afterAnimate={() => {
              const videoLab = document.getElementById('video-4-lab-nat');
              if (videoLab) {
                const timer = setTimeout(() => {
                  videoLab.click();
                  clearTimeout(timer);
                }, 200);
              }
            }}
          >
          {/*<a
            className="bg-izRuText text-white text-md font-serif px-7 py-3.5 rounded-full"
            href="https://iz.ru/1180484/anna-urmantceva/pervye-zarazheniia-mogli-byt-i-v-sentiabre-2019-go"
            target="_blank"
            rel="noreferrer"
          >*/}
            Полное интервью
          </Scrollchor>
        </div>
      </SimpleLightBox>
      <SimpleLightBox open={open[1].value} onClick={() => toggleOpen(1)}>
        <div className={isDesktopOrLaptop ? "w-full h-full" : "portrait:absolute portrait:top-2/4 portrait:transform portrait:-translate-y-2/4 portrait:pt-55 landscape:h-full landscape:w-full mb-17 left-2.5 right-2.5"}>
          <iframe className={isDesktopOrLaptop ? "w-full h-full" : "portrait:absolute top-0 -left-0 w-full h-full" }  width="560" height="315" src="https://www.youtube.com/embed/PlmYgejRDYc?enablejsapi=1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
        </div>
        <div className="flex absolute lg:relative bottom-5 lg:bottom-0 justify-center mt-5">
          <Scrollchor
            className="bg-izRuText text-white text-md font-serif px-7 py-3.5 rounded-full"
            animate={{ duration: 1000, easing: easeOutQuad, offset: 0 }}
            to="#interview"
            beforeAnimate={() => toggleOpen(1)}
            afterAnimate={() => {
              const videoLab = document.getElementById('video-4-lab-nat');
              if (videoLab) {
                const timer = setTimeout(() => {
                  videoLab.click();
                  clearTimeout(timer);
                }, 200);
              }
            }}
          >
          {/*<a
            className="bg-izRuText text-white text-md font-serif px-7 py-3.5 rounded-full"
            href="https://iz.ru/1186209/anna-urmantceva/v-blizhaishie-gody-v-prirode-naidut-istochnik-sars-cov-2"
            target="_blank"
            rel="noreferrer"
          >*/}
            Полное интервью
          </Scrollchor>
        </div>
      </SimpleLightBox>
      <div
        className="
          max-w-1160
          mx-auto
          flex
          flex-col
          lg:flex-row
          justify-between
          w-full
          text-white
          rounded-2.5xl
          lg:pb-15
          mb-10
          lg:mb-0
          video-in-view-3
        "
      >
        {showNotActive && <div className="pl-5 lg:pl-15 pr-5 flex-1">
          <div
            className="relative mb-5"
          >
            {isDesktopOrLaptop && <div
              className="video-img-left-3 absolute -left-1/3 -ml-5 top-4"
            >
              <img
                src={mainImgLeft}
                width="270"
                height="270"
                alt=""
              />
            </div>}
            <div
              id="video-3-lab"
              onClick={() => toggleOpen(0)}
              className="
                relative
                pt-63
                w-full
                lg:pt-0
                flex
                cursor-pointer
                z-10
                bg-redText
                rounded-2.5xl
                hover-zoom
              "
            >
              <Parallax
                animation={{ x: 0, opacity: 1, playScale: [0.20, 0.50] }}
                style={{ transform: 'translateX(50px)', opacity: 0 }}
                className="absolute left-2/4 -ml-28 lg:-ml-36 -mt-21 lg:mt-12 top-2/4 lg:top-0"
              >
                <img
                  src={mainImgLeft2}
                  width={isDesktopOrLaptop ? "162" : "117" }
                  height={isDesktopOrLaptop ? "210" : "151" }
                  alt=""
                />
              </Parallax>

              <img
                className="absolute lg:relative left-2/4 top-2/4 lg:top-0 -mt-16 lg:mt-10 my-10.5 -ml-20 lg:-ml-31"
                
                src={mainImgLeft1}
                width={isDesktopOrLaptop ? "244" : "151" }
                height={isDesktopOrLaptop ? "207" : "128" }
                alt=""
              />

              <Parallax
                animation={{ x: 0, opacity: 1, playScale: [0.20, 0.50] }}
                style={{ transform: 'translateX(-50px)', opacity: 0 }}
                className="absolute left-2/4 lg:left-3/4 -ml-0 lg:-ml-32 -mt-18 lg:-mt-0 top-2/4 lg:top-6"
              >
                <img
                  src={mainImgLeft3}
                  width={isDesktopOrLaptop ? "136" : "76" }
                  height={isDesktopOrLaptop ? "148" : "84" }
                  alt=""
                />
              </Parallax>

              <img
                className="absolute left-2/4 top-2/4 -ml-8 lg:-ml-13 -mt-8 lg:-mt-13 filter drop-shadow-4xl transition"
                src={playBtn}
                width={isDesktopOrLaptop ? "101" : "60" }
                height={isDesktopOrLaptop ? "101" : "60" }
                alt=""
              />
            </div>
          </div>

          <h3 className="text-md font-serif font-bold mb-2.5">
            Константин Крутовский
          </h3>
          <p className="text-md font-serif leading-6.5 m-0">
            Профессор кафедры геномики и биоинформатики СФУ, профессор Геттингенского университета; генетик
          </p>
        </div>}
        {showActive && <div className="pl-5 pr-5 lg:pr-15 flex-1">
          <div
            className="relative mb-5"
          >
            {isDesktopOrLaptop && <div
              className="video-img-right-3 absolute -right-1/3 -mr-9 top-18"
            >
              <img
                src={mainImgRight}
                width="346"
                height="218"
                alt=""
              />
            </div>}
            <div
              id="video-3-nat"
              onClick={() => toggleOpen(1)}
              className="
                relative
                pt-63
                w-full
                lg:pt-0
                flex
                cursor-pointer
                z-10
                bg-greenText
                rounded-2.5xl
                hover-zoom
              "
            >
              <Parallax
                animation={{ x: 0, opacity: 1, playScale: [0.20, 0.50] }}
                style={{ transform: 'translateX(5px)', opacity: 0 }}
                className="absolute left-2/4 -ml-32 -mt-20 lg:-mt-0 lg:-ml-56 top-2/4 lg:top-0"
              >
                <img
                  src={mainImgRight2}
                  width={isDesktopOrLaptop ? "425" : "240" }
                  height={isDesktopOrLaptop ? "291" : "164" }
                  alt=""
                />
              </Parallax>

              <img
                className="absolute lg:relative left-2/4 top-2/4 lg:top-0 -mt-16 lg:mt-10 my-10.5 -ml-20 lg:-ml-31"
                
                src={mainImgRight1}
                width={isDesktopOrLaptop ? "244" : "151" }
                height={isDesktopOrLaptop ? "207" : "128" }
                alt=""
              />
              <img
                className="absolute left-2/4 top-2/4 -ml-8 lg:-ml-13 -mt-8 lg:-mt-13 filter drop-shadow-4xl transition"
                src={playBtn}
                width={isDesktopOrLaptop ? "101" : "60" }
                height={isDesktopOrLaptop ? "101" : "60" }
                alt=""
              />
            </div>
          </div>

          <h3 className="text-md font-serif font-bold mb-2.5">
            Александр Панчин
          </h3>
          <p className="text-md font-serif leading-6.5 m-0">
            Биоинформатик, старший научный сотрудник Института проблем передачи информации имени А.А. Харкевича РАН, член Комиссии РАН по борьбе с лженаукой
          </p>
        </div>}
      </div>
    </>
  );
}